import "./Quantity.css";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";

function Quantity({ product }) {
  let [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const itemsInCart = useSelector((state) => state.shoppingCart);
  const productInCart = itemsInCart.find((object) => object._id === product._id);

  let quantityOfProductInCart = 0;
  if (productInCart) {
    quantityOfProductInCart = productInCart.quantity;
  }
  /* if (quantity + quantityOfProductInCart > product.stock) {
    
  } */
  const handleAddItem = () => {
    dispatch({
      type: "ADD_ITEM",
      payload: { ...product, quantity },
    });
    toast.info(` Se ha agregado un item a su carrito!`, {
      position: "top-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showNoStockToast = () => {
    toast.error(
      <>
        <p>😪 No hay mas stock :</p>
        <p>{product.name}</p>
      </>,
      {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      },
    );
  };

  const decrementQuantity = (ev) => {
    if (quantity <= 1) {
      setQuantity(1);
    } else {
      setQuantity(quantity - 1);
    }
  };
  const incrementQuantity = (ev) => {
    setQuantity(quantity + 1);
  };

  return (
    <div className="row d-flex justify-content-between align-items-center">
      <hr className="mb-3" />
      <div className="col-6 p-0 mb-2">
        <button className="btn btn-sm btn-outline-secondary" onClick={() => decrementQuantity()}>
          -
        </button>
        <p className="d-inline m-2">{quantity}</p>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            if (quantity + quantityOfProductInCart < product.stock) {
              incrementQuantity();
            } else {
              showNoStockToast();
            }
          }}
        >
          +
        </button>
      </div>
      <div className="col-6 p-0 mb-2">
        {product.stock - quantityOfProductInCart <= 0 ? (
          <button
            className="btn btn-danger"
            style={{ fontSize: "0.7rem", height: "2rem", width: "100%" }}
            disabled
          >
            Sin stock
          </button>
        ) : (
          <button
            className="btn btn-success"
            style={{ fontSize: "0.7rem", height: "2rem", width: "100%" }}
            onClick={() => {
              handleAddItem();
              setQuantity(1);
            }}
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M23.76 4.248c-0.096-0.096-0.24-0.24-0.504-0.24h-18.48l-0.48-2.4c-0.024-0.288-0.384-0.528-0.624-0.528h-2.952c-0.384 0-0.624 0.264-0.624 0.624s0.264 0.648 0.624 0.648h2.424l2.328 11.832c0.312 1.608 1.848 2.856 3.48 2.856h11.28c0.384 0 0.624-0.264 0.624-0.624s-0.264-0.624-0.624-0.624h-11.16c-0.696 0-1.344-0.312-1.704-0.816l14.064-1.92c0.264 0 0.528-0.24 0.528-0.528l1.968-7.824v-0.024c-0.024-0.048-0.024-0.288-0.168-0.432zM22.392 5.184l-1.608 6.696-14.064 1.824-1.704-8.52h17.376zM8.568 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM9.888 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.32-0.624-1.32-1.32 0.624-1.32 1.32-1.32 1.32 0.624 1.32 1.32zM18.36 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM19.704 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.344-0.6-1.344-1.32 0.624-1.32 1.32-1.32 1.344 0.624 1.344 1.32z"></path>
            </svg>
            <span className=""> Agregar</span>
          </button>
        )}
        {/* <button
          className="btn btn-success"
          style={{ fontSize: "0.7rem", height: "2rem", width: "100%" }}
          onClick={() => {
            handleAddItem();
            setRefreshComponent((prev) => !prev);
          }}
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M23.76 4.248c-0.096-0.096-0.24-0.24-0.504-0.24h-18.48l-0.48-2.4c-0.024-0.288-0.384-0.528-0.624-0.528h-2.952c-0.384 0-0.624 0.264-0.624 0.624s0.264 0.648 0.624 0.648h2.424l2.328 11.832c0.312 1.608 1.848 2.856 3.48 2.856h11.28c0.384 0 0.624-0.264 0.624-0.624s-0.264-0.624-0.624-0.624h-11.16c-0.696 0-1.344-0.312-1.704-0.816l14.064-1.92c0.264 0 0.528-0.24 0.528-0.528l1.968-7.824v-0.024c-0.024-0.048-0.024-0.288-0.168-0.432zM22.392 5.184l-1.608 6.696-14.064 1.824-1.704-8.52h17.376zM8.568 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM9.888 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.32-0.624-1.32-1.32 0.624-1.32 1.32-1.32 1.32 0.624 1.32 1.32zM18.36 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM19.704 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.344-0.6-1.344-1.32 0.624-1.32 1.32-1.32 1.344 0.624 1.344 1.32z"></path>
          </svg>
          <span className="ps-2"> Agregar</span>
        </button> */}
      </div>
    </div>
  );
}
export default Quantity;
